import { useQuery } from '@tanstack/react-query';
import { fetchListaEventosDocumentos, type ListaEventosFiltro } from '../api/ListaEventosApi';

export function useListaEventos(filtro: ListaEventosFiltro, enabled: boolean) {
  return useQuery({
    queryKey: ['lista-eventos-documentos', filtro],
    queryFn: () => fetchListaEventosDocumentos(filtro),
    enabled,
    staleTime: 60_000,
  });
}
